module.exports = __webpack_public_path__ + "img/landscape-placeholder.6af75fb9.svg";